import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';
import { isScreenBelow400 } from 'store/common/settings/breakpoint/selectors';
import { showThreeFoursModal } from 'store/widgets/ThreeFours/actions';
import { getUserIsAuthenticated } from 'store/common/header/selectors';
import {
  getThreeFoursAuthFormData,
  getThreeFoursOfferUrl,
  getThreeFoursRedirectUrl,
  getThreeFoursCatalogBackgrounds,
  getThreeFoursIsLightTheme,
  getThreeFoursOfferUrlTitle,
  getThreeFoursPreAuthButtonText,
} from 'store/widgets/ThreeFours/selectors';
import { Link, Heading } from 'components';
import { LinkBlock } from 'bricks';

import AuthForm from '../AuthForm';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

class CatalogBanner extends React.Component {
  handleRedirect = () => {
    const { redirectUrl } = this.props;
    window.location.href = redirectUrl;
  };

  render() {
    const {
      isMobile,
      isLight,
      isAuthenticated,
      authFormData,
      offerUrl,
      offerUrlTitle,
      preAuthButtonText,
      onMobileBannerClick,
      background,
      backgroundImage,
      mobileBackground,
      mobileBackgroundImage,
      isBelowMobile,
    } = this.props;
    return (
      <LinkBlock
        className={cx('container', { light: isLight })}
        onClick={isMobile ? (isAuthenticated && this.handleRedirect) || onMobileBannerClick : null}
      >
        {isBelowMobile ?
          <div
            className={cx('bg')}
            style={{
              background: mobileBackground,
              backgroundImage: `url('${mobileBackgroundImage}')`,
            }}
          />
        : <div
            className={cx('bg')}
            style={{ background, backgroundImage: `url('${backgroundImage}')` }}
          />
        }
        <div className={cx('content')}>
          <Heading tagName="div" level={isMobile ? 5 : 4} className={cx('heading')}>
            {authFormData.title}
          </Heading>
          <div className={cx('description')}>{authFormData.description}</div>
          {!isMobile ?
            <>
              <AuthForm
                {...authFormData}
                setFocus={false}
                onRedirect={this.handleRedirect}
                onAuthOpen={() => {}}
                onBannerClick={() => {}}
                className={cx('form')}
                isLight={isLight}
              />
              {offerUrl && offerUrlTitle ?
                <Heading tagName="div" level={5} className={cx('link')}>
                  <Link href={offerUrl}>{offerUrlTitle}</Link>
                </Heading>
              : null}
            </>
          : preAuthButtonText && <div className={cx('button')}>{preAuthButtonText}</div>}
        </div>
      </LinkBlock>
    );
  }
}

CatalogBanner.propTypes = {
  isMobile: PropTypes.bool,
  isBelowMobile: PropTypes.bool,

  /** redux connected props */
  isLight: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  authFormData: PropTypes.object,
  offerUrl: PropTypes.string,
  offerUrlTitle: PropTypes.string,
  redirectUrl: PropTypes.string,
  preAuthButtonText: PropTypes.string,
  onMobileBannerClick: PropTypes.func,

  /** redux connected through getThreeFoursCatalogBackgrounds */
  background: PropTypes.string,
  backgroundImage: PropTypes.string,
  mobileBackground: PropTypes.string,
  mobileBackgroundImage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isLight: getThreeFoursIsLightTheme(state),
  isBelowMobile: isScreenBelow400(state),
  isAuthenticated: getUserIsAuthenticated(state),
  authFormData: getThreeFoursAuthFormData(state),
  offerUrl: getThreeFoursOfferUrl(state),
  offerUrlTitle: getThreeFoursOfferUrlTitle(state),
  redirectUrl: getThreeFoursRedirectUrl(state),
  preAuthButtonText: getThreeFoursPreAuthButtonText(state),
  /**
   * Retrieves:
   * - backgroundImage,
   * - background,
   * - mobileBackgroundImage,
   * - mobileBackground */
  ...getThreeFoursCatalogBackgrounds(state),
});

const mapDispatchToProps = {
  onMobileBannerClick: showThreeFoursModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogBanner);
